import { ref, onMounted } from "vue";
import { templateRef } from "@vueuse/core";
import { useScrollTriggerAnimation } from "/composables/useScrollTriggerAnimation";


export default {
  __name: 'index',
  props: {
  items: {
    type: Array,
    required: true,
  },
  mediaSizes: {
    type: Object,
    required: true,
  },
  align: {
    type: String,
    required: false,
    validator: function (value) {
      return ["start", "end"].indexOf(value) !== -1;
    },
    default: "start",
  },
  skin: {
    type: String,
    required: false,
    validator: function (value) {
      return ["white", "red", "gray"].indexOf(value) !== -1;
    },
    default: "white",
  },
},
  setup(__props) {

const props = __props;



const { reveal } = useScrollTriggerAnimation();

const tpl_textCarouselWrapper = templateRef("tpl_textCarouselWrapper");
const tpl_textCarousel = templateRef("tpl_textCarousel");
const tpl_textSwiperEl = templateRef("tpl_textSwiperEl");
const tpl_mediaCarouselWrapper = templateRef("tpl_mediaCarouselWrapper");
const tpl_mediaCarousel = templateRef("tpl_mediaCarousel");
const tpl_mediaSwiperEl = templateRef("tpl_mediaSwiperEl");
const swiperText = ref(null);
const swiperMedia = ref(null);

onMounted(() => {
  requestAnimationFrame(() => {
    const textSwiperEl = tpl_textSwiperEl.value;
    const mediaSwiperEl = tpl_mediaSwiperEl.value;

    // Configure text Swiper Element parameters
    const textSwiperParams = {
      loop: props.items.length > 1 ? true : false,
      slidesPerView: 1,
      grabCursor: false,
      allowTouchMove: false,
      parallax: { enabled: true },
      speed: 600,
    };

    // Configure media Swiper Element parameters
    const mediaSwiperParams = {
      loop: props.items.length > 1 ? true : false,
      allowTouchMove: props.items.length > 1 ? true : false,
      grabCursor: props.items.length > 1 ? true : false,
      slidesPerView: 1,
      parallax: { enabled: true },
      speed: 600,
    };

    // Assign parameters to the elements
    Object.assign(textSwiperEl, textSwiperParams);
    Object.assign(mediaSwiperEl, mediaSwiperParams);

    // Initialize Swiper Elements
    textSwiperEl.initialize();
    mediaSwiperEl.initialize();

    // Store swiper instances
    swiperText.value = textSwiperEl.swiper;
    swiperMedia.value = mediaSwiperEl.swiper;

    // Set up controller relationship
    swiperText.value.controller.control = swiperMedia.value;
    swiperMedia.value.controller.control = swiperText.value;

    reveal(
      textSwiperEl,
      tpl_textCarouselWrapper.value,
      props.align === "start" ? "right" : "left",
      {
        intensity: "strong",
        fade: false,
        duration: "long",
      }
    );
    reveal(mediaSwiperEl, tpl_mediaCarouselWrapper.value, "bottom", {
      intensity: "normal",
      fade: true,
      duration: "long",
    });
  });
});

function handlePrevNext(goto) {
  goto === "next" ? swiperText.value.slideNext() : swiperText.value.slidePrev();
}

return { __sfc: true,props, reveal, tpl_textCarouselWrapper, tpl_textCarousel, tpl_textSwiperEl, tpl_mediaCarouselWrapper, tpl_mediaCarousel, tpl_mediaSwiperEl, swiperText, swiperMedia, handlePrevNext }
}

}